import React from 'react';
import localeText from '@locale';
import {Mobile, DesktopOrTablet} from '~/components/Responsive';
import image from '~/assets/images/404.png';

import './index.less';
import './mobile.less';

const NotFound = () => (
  <>
    <DesktopOrTablet {...{[['key'][0]]: 'not-found-pc'}}>
      <div className='not-found'>
        <img src={image} alt='404' />
        <div className='hint'>
          <div className='hint1'>{localeText('COMMON.NOT_FOUND1')}</div>
          <div className='hint2'>{localeText('COMMON.NOT_FOUND2')}</div>
        </div>
      </div>
    </DesktopOrTablet>
    <Mobile {...{[['key'][0]]: 'not-found-mo'}}>
      <div className='not-found-mobile'>
        <img src={image} alt='404' />
        <div className='mobileHint'>{localeText('COMMON.NOT_FOUND_MOBILE')}</div>
      </div>
    </Mobile>
  </>
);
export default NotFound;
